<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <DashboardManager />
    </AccountViewBase>
</template>

<script>
    import { mapActions } from 'pinia';
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import DashboardManager from '@/components/account/dashboard/DashboardManager';
    import { useAccountStore } from '@/stores/account';
    import { scrollToTop } from '@/utils/scroll';

    export default {
        name: 'DashboardView',
        components: {
            AccountViewBase,
            DashboardManager
        },
        mixins: [i18nViewMixin, accountMixin],
        data() {
            return {
                seo_title: 'views.dashboard.seo_title',
                loadingStats: false
            };
        },
        computed: {
            loading() {
                return this.accountLoading || this.loadingStats;
            }
        },
        methods: {
            ...mapActions(useAccountStore, ['getProspectsStats']),
            async getStats()  {
                this.loadingStats = true;
                await this.getProspectsStats();
                this.loadingStats = false;
            },
            generateSeoTitle() {
                this.seo_title = 'views.dashboard.seo_title_account';
                this.seo_title_data = {
                    name: this.account.name
                };
                this.updateDocumentTitle();
            },
        },
        watch: {
            account: {
                async handler(newVal) {
                    if (newVal && newVal.name) {
                        this.generateSeoTitle();
                    }
                },
                immediate: true,
                deep: true
            },
        },
        mounted() {
            scrollToTop();
            this.getStats();
        }
    }
</script>
